import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

class LocalSocket {
  constructor() {
    this.listeners = new Map();
    window.setTimeout(() => this.notify("connect"), 0);
  }

  on(event, handler) {
    const handlers = this.listeners.get(event) || new Set();
    handlers.add(handler);
    this.listeners.set(event, handlers);
    return this;
  }

  off(event, handler) {
    this.listeners.get(event)?.delete(handler);
    return this;
  }

  emit() {
    return this;
  }

  disconnect() {
    this.listeners.clear();
  }

  notify(event, payload) {
    this.listeners.get(event)?.forEach(handler => handler(payload));
  }
}

function connectToSocket() {
    // El adaptador local obtiene Chatwoot por REST y todavía no expone
    // Socket.IO. Evitamos reconexiones infinitas y errores 404 en pantalla;
    // las vistas activas se refrescan por consulta periódica.
    if (/^https?:\/\/(127\.0\.0\.1|localhost):4010\/?$/i.test(getBackendUrl() || "")) {
      return new LocalSocket();
    }

    const token = localStorage.getItem("token");
    return openSocket(getBackendUrl(), {
      transports: ["websocket", "polling", "flashsocket"],
      query: {
        token: JSON.parse(token),
      },
    });
}

export default connectToSocket;
